
 <template>
    <div class="cus-level" @keyup.enter="enterSearch">
      <el-form ref="form" :model="form" inline class="table-search-bar" >
        <el-form-item label="返优惠名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入返优惠名称"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择">
            <el-option
                v-for="item in statusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button type="primary" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="list"
        style="width: 100%"
        tooltip-effect="light">
        <el-table-column
          prop="code"
          label="返优惠单号"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="name"
          label="返优惠名称"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="totalApplyAmount"
          label="申请合计（元）"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="totalAuditAmount"
          label="审核合计（元）"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="policyName"
          label="返优惠产生规则名称"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="policyCode"
          label="返优惠产生规则编码"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="状态"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="applyVerifyTime"
          label="提交审核时间"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="verifyTime"
          label="审核时间"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="expireTime"
          label="到期时间"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="操作"
          width="200px">
          <template slot-scope="scope">
            <el-button @click="handleAdd(scope.row)" v-permission="'0220103'">查看</el-button>
            <el-button v-if="[0].includes(scope.row.status)" @click="handleApprove(scope.row)" v-permission="'0230201'">提交审核</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listState.total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
      <detail-dialog v-if="dialogVisible" :show.sync="dialogVisible" :info="dialogInfo"></detail-dialog>
    </div>
  </template>

<script>
import { mapActions, mapGetters } from 'vuex'
import detailDialog from './detailDialog'
export default {
  name: 'rebateApproval',
  components: { detailDialog },
  data () {
    return {
      form: {
        status: '',
        name: ''
      },
      dialogVisible: false,
      dialogInfo: {},
      statusArr: [
        { value: '', label: '全部' },
        { value: 0, label: '待提交' },
        { value: 1, label: '待审核' },
        { value: 2, label: '已审核' },
        { value: 3, label: '审核不通过' },
        { value: 4, label: '已超期' }
      ]
    }
  },
  computed: {
    ...mapGetters({ list: 'getRebateFormList', listState: 'getRebateFormListState' })
  },
  methods: {
    ...mapActions(['getRebateFormList', 'carrierStatusChanage', 'auditRebateAuditForm']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = { ...this.form, pageNo: 1, pageSize: 10 }
      this.getRebateFormList(params)
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getRebateFormList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getRebateFormList({ pageSize: 1, pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.$refs.form.resetFields()
      this.handleSearch()
    },
    // 新增
    handleAdd (row) {
      this.dialogInfo = row
      this.dialogVisible = true
    },
    // 开启或者停用
    handleApprove (row) {
      this.$confirm('提交审核后发起审批流程，是否确认提交', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.auditRebateAuditForm({ id: row.id })
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.handleSearch()
      }).catch(() => {
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

  <style scoped>

  </style>
